module.exports = __webpack_public_path__ + "static/media/JustActMailers_7_V1-01.cd603cab.jpg";